import { Link } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import AudioPlayer from './AudioPlayer';

const VirtualReceptionistHero = () => (
  <header className="relative overflow-hidden px-4 pb-20 pt-36 sm:px-6 lg:px-8">
    <div className="absolute left-1/2 top-24 h-96 w-96 -translate-x-1/2 rounded-full bg-blue-600/20 blur-[120px]" />
    <div className="relative mx-auto max-w-6xl text-center">
      <div className="mb-7 inline-flex items-center gap-2 rounded-full border border-emerald-400/30 bg-emerald-400/10 px-4 py-2 text-sm font-semibold text-emerald-300">
        <span className="h-2 w-2 animate-pulse rounded-full bg-emerald-400" />
        The modern alternative to expensive answering services
      </div>
      <h1 className="text-5xl font-extrabold leading-tight tracking-tight text-white md:text-7xl">
        24/7 AI Virtual Receptionist for Small Business
      </h1>
      <p className="mx-auto mt-7 max-w-3xl text-lg leading-relaxed text-slate-300 md:text-xl">
        Move beyond per-minute virtual receptionist services. AutoReception answers instantly, captures lead details, books appointments, and routes urgent calls around the clock.
      </p>
      <div className="mt-9 flex flex-col justify-center gap-4 sm:flex-row">
        <Link to="/ai-receptionist-for-small-business" className="inline-flex items-center justify-center gap-2 rounded-full bg-blue-600 px-8 py-4 text-lg font-bold text-white shadow-[0_0_25px_rgba(37,99,235,0.4)] transition hover:bg-blue-500">
          Try AutoReception Free
          <SafeIcon name="ArrowRight" />
        </Link>
        <a href="#savings" className="inline-flex items-center justify-center gap-2 rounded-full border border-slate-700 bg-slate-800 px-8 py-4 text-lg font-bold text-white transition hover:bg-slate-700">
          Calculate Your Cost Savings
          <SafeIcon name="Calculator" />
        </a>
      </div>
      <p className="mt-6 text-sm font-semibold text-blue-200">
        Handle 100% of calls on ring one at a fraction of the cost of legacy virtual receptionist services.
      </p>
      <div className="mx-auto mt-12 max-w-2xl">
        <AudioPlayer />
      </div>
    </div>
  </header>
);

export default VirtualReceptionistHero;